"use client"

import { useTranslations } from "next-intl"

import { ACCEPT_ALL, REJECT_ALL } from "@workspace/analytics"
import { ConsentBanner as ConsentBannerView } from "@workspace/ui/components/consent-banner"

import { useAnalytics } from "./analytics-provider"

/**
 * Connects the presentational `ConsentBanner` (@workspace/ui) to the analytics
 * context. Shown only when a tag is configured, and then to a diner who hasn't
 * decided yet — or who reopened it from the footer "Cookie settings" link.
 * Renders nothing until the consent cookie has been read on the client, so a
 * returning diner never sees it flash.
 */
export function ConsentBanner() {
  const t = useTranslations("consent")
  const { tag, consent, settingsOpen, saveConsent } = useAnalytics()

  // No tag, cookie not read yet, or already decided (and not reopened).
  if (!tag || consent === undefined || (consent && !settingsOpen)) return null

  return (
    <ConsentBannerView
      // Remount per opening so the switches start from the saved choice.
      key={settingsOpen ? "settings" : "first-visit"}
      open
      initialChoice={consent ?? undefined}
      defaultCustomising={settingsOpen}
      onAcceptAll={() => saveConsent(ACCEPT_ALL)}
      onRejectAll={() => saveConsent(REJECT_ALL)}
      onSave={saveConsent}
      labels={{
        title: t("title"),
        description: t("description"),
        acceptAll: t("acceptAll"),
        rejectAll: t("rejectAll"),
        customise: t("customise"),
        save: t("save"),
        necessaryLabel: t("necessaryLabel"),
        necessaryDescription: t("necessaryDescription"),
        analyticsLabel: t("analyticsLabel"),
        analyticsDescription: t("analyticsDescription"),
        adsLabel: t("adsLabel"),
        adsDescription: t("adsDescription"),
      }}
    />
  )
}
